import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralLinkComponent } from './referral-link/referral-link.component';
import { ReferralSocialComponent } from './referral-social/referral-social.component';
import { ShareModule } from 'ngx-sharebuttons';
import {
    AlertModule,
    ButtonModule,
    CardModule,
    ModalsModule,
    SosAccountStoreModule,
    SosCoreModule,
} from '@serviceos-ng/core';
import { ReferralStatsComponent } from './referral-stats/referral-stats.component';
import { InviteSocialModalComponent } from './invite-social-modal/invite-social-modal.component';

@NgModule({
    declarations: [
        ReferralLinkComponent,
        ReferralSocialComponent,
        ReferralStatsComponent,
        InviteSocialModalComponent,
    ],
    imports: [
        CommonModule,
        SosCoreModule,
        ShareModule,
        SosAccountStoreModule,
        ModalsModule,
        ButtonModule,
        HttpClientModule,
        AlertModule,
        CardModule,
    ],
    exports: [
        ReferralLinkComponent,
        ReferralSocialComponent,
        ReferralStatsComponent,
        InviteSocialModalComponent,
    ],
})
export class ReferralModule {}
